<div class="progress-bar" *ngIf="loadingStatus$ | async">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<router-outlet></router-outlet>
